// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MenuListDisplayItem-module-item {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  background-color: var(--secondary-button-background);
  padding: 15px;
  border-radius: 5px;
  gap: 15px;
}`, "",{"version":3,"sources":["webpack://./src/Router/App/components/menu-list-items/MenuListDisplayItem/MenuListDisplayItem.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,2BAA2B;EAC3B,sBAAsB;EACtB,oDAAoD;EACpD,aAAa;EACb,kBAAkB;EAClB,SAAS;AACX","sourcesContent":[".item {\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  flex-direction: column;\r\n  background-color: var(--secondary-button-background);\r\n  padding: 15px;\r\n  border-radius: 5px;\r\n  gap: 15px;\r\n}"],"sourceRoot":""}]);
// Exports
export var item = `MenuListDisplayItem-module-item`;
export default ___CSS_LOADER_EXPORT___;
